// extracted by mini-css-extract-plugin
export default {"FieldDropdown":"CategoryFieldDropdown_FieldDropdown__pfNRj"};